import * as Drawer from '@/components/ui/drawer'
import { IconButton } from '@/components/ui/icon-button'
import { X } from 'lucide-solid'
import { type JSX, type ParentProps, Show } from 'solid-js'
import { css } from 'styled-system/css'

export const AppDrawer = (
  props: ParentProps<Drawer.RootProps> & {
    title: string
    trigger?: JSX.Element
  },
) => {
  return (
    <Drawer.Root {...props}>
      <Drawer.Backdrop />
      <Show when={props.trigger}>
        <Drawer.Trigger>
          {props.trigger}
        </Drawer.Trigger>
      </Show>
      <Drawer.Positioner>
        <Drawer.Content>
          <Drawer.CloseTrigger />
          <Drawer.Header>
            <div
              class={css({
                display: 'grid',
                gridTemplateColumns: '1fr auto',
                justifyContent: 'space-between',
                alignItems: 'center',
              })}
            >
              <Drawer.Title textTransform={'capitalize'}>{props.title}</Drawer.Title>
              <Drawer.CloseTrigger
                asChild={(closeProps: any) => (
                  <IconButton
                    size="xs"
                    variant="subtle"
                    colorPalette="accent"
                    {...closeProps}
                  >
                    <X />
                  </IconButton>
                )}
              />
            </div>
          </Drawer.Header>
          <Drawer.Body pt={0}>
            {props.children}
          </Drawer.Body>
        </Drawer.Content>
      </Drawer.Positioner>
    </Drawer.Root>
  )
}
